import { useInfiniteQuery } from "@tanstack/react-query";
import type { PaginatedMediaResponse } from "shared";
import { Api } from "../api.config";
import { useCompany } from "../company/useCompany";
import { QueryKeys } from "../LinkGen";

const PAGE_SIZE = 50;

export function useMediaPage(opts: {
	folderId?: number | null;
	query?: string;
	source?: string;
}) {
	const { id: companyID } = useCompany();

	return useInfiniteQuery<PaginatedMediaResponse>({
		queryKey: QueryKeys.Files.Page(
			companyID,
			opts.folderId,
			opts.query,
			opts.source,
		),
		queryFn: async ({ pageParam }) => {
			const res = await Api.GetMediaPage({
				folderId: opts.folderId,
				cursor: pageParam as number | undefined,
				limit: PAGE_SIZE,
				query: opts.query,
				source: opts.source,
			});
			return res.data;
		},
		initialPageParam: undefined as number | undefined,
		getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
	});
}
